/**
 * Created by bob.gear on 30/05/2015.
 */
/*
Now here's the thing - all of the project summary  controllers and layouts are called from
the search module.

This is not what I  want longer term. There is a base class for the project summary which
should be able to exist in one module, then I want to be able to subclass (prototypically)
in another module so that, notifications, say, can inherit and extend the behaviour
 */
var EICDataStream3ProjectNotifications = angular.module('EICDataStream3.projectNotifications', []) // <-- add dependencies here

.controller('ProjectNotificationSummaryController', ['$scope', '$stateParams', '$state', '$location', 'projectWatchSummaryDataService',
  'trackingStatusService', 'watchService', 'reportRequestService', 'summaryDownloadService', 'geographicalProjectPresenterService',
  'exportRequestService', 'FEATURE_SWITCHES',
  function ($scope, $stateParams, $state, $location, projectWatchSummaryDataService,
    trackingStatusService, watchService, reportRequestService, summaryDownloadService, geographicalProjectPresenterService,
    exportRequestService, FEATURE_SWITCHES) {
    $scope.componentName = "ProjectNotificationSummaryController";

    $scope.FEATURE_SWITCHES = FEATURE_SWITCHES;
    $scope.WATCHES = FEATURE_SWITCHES.WATCHES;
    $scope.NEW_REPORT_REQUEST = FEATURE_SWITCHES.NEW_REPORT_REQUEST;
    $scope.NEW_EXPORTS = FEATURE_SWITCHES.NEW_EXPORTS;


    $scope.projectWatchSummaryDataService =  projectWatchSummaryDataService;
    $scope.dataFlowControl =  projectWatchSummaryDataService.dataFlowControl;
    $scope.trackingStatusService =  trackingStatusService;


    // use the watch guid to fetch back the characteristics of the watch - name etc.
    $scope.watchGuid =  $stateParams.guid;

    $scope.projectPresentation = {
      highlightSince: "",
      newSince: ""
    };

    $scope.restoreProject = function(projectID){
      // here we send off a request via the watchService to  restore the project
      return watchService.restoreProject($scope.watchGuid, projectID)
        .then(function() {
          // sort out the project's style
          for(var i=0; i< $scope.dataFlowControl.items.length; i++){
            var item = $scope.dataFlowControl.items[i];
            if (item.projectID==projectID){
              $scope.dataFlowControl.items[i].excluded = false;
            }
          };
      });
    };

    $scope.enableWatch = function(watch) {
      watchService.enableWatch(watch);
    };

    $scope.$watch("dataFlowControl.guid", function(){
      if (!$scope.dataFlowControl.guid) return;
      $scope.source = "projectwatch";
      $scope.summaryGuid = $scope.dataFlowControl.guid;

      $scope.projectPresentation.updatedSince = (!$scope.dataFlowControl.lastNotified) ? 'never'
        : $scope.dataFlowControl.lastNotified;

      //$scope.projectPresentation.highlightSince = (!$scope.dataFlowControl.lastNotified) ? $scope.dataFlowControl.created
      //  : $scope.dataFlowControl.lastNotified;
      $scope.projectPresentation.highlightSinceDate = $scope.dataFlowControl.highlightSinceDate;

      $scope.projectPresentation.newSince = (!$scope.dataFlowControl.lastNotified) ? $scope.dataFlowControl.created
        : $scope.dataFlowControl.lastNotified;

      //$scope.projectPresentation.selectedTrackingStatuses = $scope.projectPresentation.selectedTrackingStatuses;
    });



    //$scope.$watch("projectWatchSummaryDataService.dataFlowControl.queryDef", function(){
    //  if (!projectWatchSummaryDataService.dataFlowControl.queryDef) return;
    //
    //$scope.projectPresentation.highlightSince = (!$scope.dataFlowControl.queryDef.lastNotified) ? 'never'
    //  : $scope.dataFlowControl.queryDef.lastNotified;
    //
    //$scope.projectPresentation.newSince = (!$scope.dataFlowControl.queryDef.lastNotified) ? $scope.dataFlowControl.queryDef.created
    //  : $scope.dataFlowControl.queryDef.lastNotified;
    //
    //
    //}, true);

    var initialSort = {
      sortField: "projectUpdated",
      sortDesc: true
    };


    /**************************************************************************
     *  Project Selections
     **************************************************************************/
    // Function to determine if any projects in the list have been selected
    // This is used to determine which options are available on the
    // Actions menu.
    $scope.areAnyProjectsChecked = function () {
      return ($scope.projectSelectionSummary.numberOfProjectsSelected > 0);
    }
    $scope.areAllProjectsChecked = function () {
      return ($scope.projectSelectionSummary.areAllProjectsSelected);
    }
    // this structure is passed into the Projects display directive.
    // it allows values to be passed out again, as well as pre and post
    // selection special actions
    $scope.projectSelectionSummary = {
      projectSelecting: function (projectID, isChecked) { },
      projectSelected: function (projectID, isChecked) { },

      numberOfProjectsSelected: 0,
      areAnyProjectsSelected: false,
      areAllProjectsSelected: false,
      projectIDs: [],
      resetSelections: function(){
        this.projectIDs.length=0;
      }
    };

    /**************************************************************************
     *   Action Menu
     **************************************************************************/
    $scope.currentPath = function() {
      // ie objects to the # character and ignores everything that  follows it.
      // Encoding the # in hex (%23) allows outlook to  process the url properly
      // when called from ie
      return $location.absUrl().replace("#", "%23");
    };



    $scope.exportSummary = function () {
      return summaryDownloadService.projectWatch($scope.summaryGuid);
    };

    $scope.stopWatchingSelectedProjects = function() {
      // Gather up the list of selected projects and send back to the project watch
      // controller in a suitably  formatted patch

      watchService.stopWatchingProjects({watchGuid: $scope.watchGuid,
                                         projectIDs: $scope.projectSelectionSummary.projectIDs}).then(function(){
        for(var i=0; i< $scope.dataFlowControl.items.length; i++){
          var item = $scope.dataFlowControl.items[i];
          if ($scope.projectSelectionSummary.projectIDs.indexOf(item.projectID)>-1){
            $scope.dataFlowControl.items[i].excluded = true;
          }
        }
        // experiment - here is a possible place to unselect the selected projects
        $scope.projectSelectionSummary.resetSelections();

      });
    };

    $scope.share = function(){
      return "mailto:?subject=Search Result from EICDataStream&body=I thought you might be interested in this list of projects from EICDataStream:%0D%0A%0D%0A{{currentPath}}%0D%0A%0D%0A".replace("{{currentPath}}", $scope.currentPath());
    };
    $scope.actionMenu = {
      items: [
        // {
        //   text: "Export Summary",
        //   actionType: "function",
        //   action: $scope.exportSummary,
        //   visible: function () { return !$scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED; },
        //   disabled: $scope.areAnyProjectsChecked
        // },
        {
          text: "Export Summary...",
          actionType: "function",
          action: exportRequestService.openProjectExportRequestDialog,
          visible: function () {
            // return true;
            return $scope.NEW_EXPORTS.PROJECT_EXPORT_ENABLED && !$scope.NEW_EXPORTS.SUSPENDED;;
          },
          disabled: function () { return false }
        },
        {
          text: "Export Service Suspended",
          actionType: "function",
          action: function () { },
          visible: function () {
            return $scope.NEW_EXPORTS.SUSPENDED;
          },
          disabled: function () { return true }
        },
        {
          text: "Share...",
          actionType: "href",
          action: $scope.share,
          visible: function() { return true;},
          disabled: function(){ return  $scope.areAnyProjectsChecked() || $scope.WATCHES.SHARE_DISABLED }
        },
        {
          text: "PDF of selected projects...",
          actionType: "function",
          action: reportRequestService.openReportRequestDialog_selectedProjects,
          visible: function () {
            return $scope.areAnyProjectsChecked() && $scope.WATCHES.SELECTED_PROJECTS_PDF_ENABLED;
          },
          disabled: function () { return false }
        },
        {
          text: "PDF of projects updated since last notification...",
          actionType:"function",
          action: reportRequestService.openReportRequestDialog_selectedProjects,
          visible: function () { return $scope.WATCHES.UPDATED_PROJECTS_PDF_ENABLED; },
          disabled: function() { return !$scope.areAnyProjectsChecked(); }
        },

        {
          text: "Stop watching selected projects",
          actionType:"function",
          action: $scope.stopWatchingSelectedProjects,
          visible: function() { return true;},
          disabled:  function() { return !$scope.areAnyProjectsChecked() || $scope.areAllProjectsChecked(); }
        },
        {
          isDivider: true,
          visible: function () {
            return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
          }
        },
        {
          text: "Show selected projects on a map... (Beta)",
          actionType: "function",
          action: geographicalProjectPresenterService.post_selectedProjects,
          visible: function () {
            return FEATURE_SWITCHES.GEOGRAPHICAL_PROJECT_PRESENTER.enabled;
          },
          disabled: function () { return !$scope.areAnyProjectsChecked(); }
        }        //,
        //{
        //  text: "PDF of results of this search...(new)",
        //  actionType:"function",
        //  action: $scope.openReportRequestDialog_searchResult,
        //  visible: function(){
        //    return !$scope.areAnyProjectsChecked() && $scope.NEW_REPORT_REQUEST.CRITERIA_PROJECTS_ENABLED
        //  },
        //  disabled: false
        //}
        

      ]
    }
    /**************************************************************************/


    $scope.$on("SORT_CHANGED", function (event, sort) {
      projectWatchSummaryDataService.search($scope.watchGuid, sort);
    });


    // search method kicks the whole process off by  giving a searchID
    // which is retrieved and used to  fetch the first page
    projectWatchSummaryDataService.search($scope.watchGuid, initialSort);

  }]);
